// Pure study-stat helpers shared by the extension SW (computing from Dexie
// review_logs) and the webapp (computing from the server's distinct-day
// list). Days are LOCAL calendar days — streaks follow the studier's clock.

/** Local calendar day for a ms timestamp, as "YYYY-MM-DD". */
export function localDayString(ms: number): string {
  const d = new Date(ms);
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
}

/** Start of the local calendar day containing `ms`. */
export function localDayStartMs(ms: number): number {
  const d = new Date(ms);
  d.setHours(0, 0, 0, 0);
  return d.getTime();
}

/**
 * Consecutive-day study streak ending today (or yesterday — a streak is
 * still "alive" before today's first review). `days` is any collection of
 * "YYYY-MM-DD" local day strings with at least one review.
 */
export function computeStreakDays(days: Iterable<string>, now: number): number {
  const set = days instanceof Set ? (days as Set<string>) : new Set(days);
  if (set.size === 0) return 0;
  const DAY_MS = 24 * 60 * 60 * 1000;
  // Anchor on today if studied today, else yesterday; else no streak.
  // Walk in local-noon steps so DST shifts can't skip or repeat a day.
  let cursor = localDayStartMs(now) + DAY_MS / 2;
  if (!set.has(localDayString(cursor))) {
    cursor -= DAY_MS;
    if (!set.has(localDayString(cursor))) return 0;
  }
  let streak = 0;
  while (set.has(localDayString(cursor))) {
    streak += 1;
    cursor -= DAY_MS;
  }
  return streak;
}

/** Whole days from now until `examDate` (ms), never negative; 0 = today. */
export function daysUntil(examDate: number, now: number): number {
  const DAY_MS = 24 * 60 * 60 * 1000;
  const diff = localDayStartMs(examDate) - localDayStartMs(now);
  return Math.max(0, Math.round(diff / DAY_MS));
}
